import {BaseService} from "./BaseService";
import {PrintJob} from "../entities/PrintJob";
import { StateService } from "@uirouter/angularjs";

export class PrintJobService extends BaseService<PrintJob>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, PrintJob);
    }
    protected getBaseUrl():string{
        return "printjob";
    }
    getNew(amsName:string, lastId:number):ng.IPromise<PrintJob[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"getNew?amsName="+amsName+"&lastId="+lastId, config);
    }

    print(printJob:PrintJob):ng.IPromise<number>{
      return this.usePostHandler(this.getBaseUrl(),"print", printJob);
    }

    printtest(printJob:PrintJob):ng.IPromise<string>{
      return this.usePostHandler(this.getBaseUrl(),"print", printJob);
    }

    prints(printJobs:PrintJob[]):ng.IPromise<void>{
      return this.usePostHandler(this.getBasesUrl(),"print", printJobs);
    }
    generateRfid(){
        var config:any = {};
        return this.useGetHandler(this.getBaseUrl(),"rfid", config);
    }
}
